// Customer Type Constants for FusionCab - Backend Compatible

export const CUSTOMER_TYPES = {
  B2C: "B2C",
  B2B: "B2B",
  GUEST: "guest",
} as const;

export type CustomerType = (typeof CUSTOMER_TYPES)[keyof typeof CUSTOMER_TYPES];
